import { initWowLibrary } from "@/scripts/helpers/wowAnimation";
import Parallax from "parallax-js";
import Stickyfill from "stickyfilljs";
import lottie from "lottie-web";
import { animationData } from "@/scripts/animation-data/animatedSignature";
import contactForm from "@/modules/blocks/contact-form/index";
import modalShow from "@/modules/containers/modal/modal";

const animateClass = ".js-ready-animate";
let animateWasPlayedFlag = false;

const initParallaxDecorations = scene => {
  const sceneForm = $(".js-form-decoration");

  if (sceneForm.length) {
    const parallaxInstanceForm = new Parallax(sceneForm[0], {
      pointerEvents: false,
      invertX: false,
      invertY: false,
      relativeInput: false
    });

    parallaxInstanceForm.friction(0.2, 0.2);
  };
};

const initParallaxMobile = () => {
  const tabletBreakpoint = 639;

  if ($(window).width() > tabletBreakpoint) {
    const scene = $(".js-decorations-key-group");
    initParallaxDecorations(scene);
  }
};

const dataAnimation = () => {
  let params = {
    container: document.getElementById("animatedSignature"),
    renderer: "svg",
    loop: false,
    autoplay: true,
    animationData: animationData
  };

  let anim;
  anim = lottie.loadAnimation(params);
};

const inView = function (element) {
  const win = $(window);
  const obj = element;
  const scrollPosition = win.scrollTop();
  const visibleArea = win.scrollTop() + win.height();
  const objEndPos = obj.offset().top;

  return visibleArea >= objEndPos && scrollPosition <= objEndPos;
};

const startAnimation = () => {
  const animate = document.querySelector(animateClass);

  if (animate !== null) {
    window.addEventListener("scroll", event => {
      if (!animateWasPlayedFlag && inView($(animate))) {
        dataAnimation();
        animateWasPlayedFlag = true;
      }
    });
  }
};

$(document).ready(function () {
  initWowLibrary();
  startAnimation();
  initParallaxMobile();
  contactForm();
  modalShow();
  Stickyfill.add($(".form-wrapper"));

  $("[data-micromodal-trigger]").click(function(e) {
    e.preventDefault();
  });
});
